import React from 'react';
import Head from 'next/head';

type Props = {
  title: string;
  description?: string;
  keywords?: string;
  canonical?: string;
  noindex?: boolean;
  ogUrl?: string;
  ogTitle?: string;
  ogDescription?: string;
  ogImage?: string;
  ogSiteName?: string;
  ogType?: string;
};

function HeadTag({
  title,
  description,
  keywords,
  canonical,
  noindex,
  ogUrl,
  ogTitle,
  ogDescription,
  ogImage,
  ogSiteName,
  ogType,
}: Props) {
  return (
    <Head>
      <title>{title}</title>
      {description ? <meta content={description} name="description" /> : null}
      {keywords ? <meta content={keywords} name="keywords" /> : null}
      {canonical ? <meta content={canonical} name="canonical" /> : null}
      {noindex ? <meta name="robots" content="noindex" /> : null}
      {ogUrl ? <meta property="og:url" content={ogUrl} /> : null}
      {ogTitle ? <meta property="og:title" content={ogTitle} /> : null}
      {ogDescription ? <meta property="og:description" content={ogDescription} /> : null}
      {ogImage ? <meta property="og:image" content={ogImage} /> : null}
      {ogSiteName ? <meta property="og:site_name" content={ogSiteName} /> : null}
      {ogType ? <meta property="og:type" content={ogType} /> : null}
      <link rel="icon" type="image/x-icon" sizes="16x16" href="/images/favicon16.ico" />
      <link rel="icon" type="image/x-icon" sizes="32x32" href="/images/favicon32.ico" />
      <link rel="icon" type="image/x-icon" sizes="48x48" href="/images/favicon48.ico" />
      <link rel="icon" type="image/png" sizes="96x96" href="/images/favicon.png" />
    </Head>
  );
}

export default HeadTag;
